/*
  SnapReserve product page (the "SnapReserve:" sections).

  What this file does:
  - Offers: one selected offer for the whole page. Every price, button and the buy bar follow it.
  - Add to cart: adds the selected offer in the background and slides out the theme's cart drawer.
  - Gallery, clips, phone check pop-up, reviews (read from the "Customer reviews" area) and the buy bar.

  Wording, prices and pictures all come from the theme editor. Nothing here needs editing to change the page.
  On wide screens Horizon scrolls the page inside .page-wrapper, not the window, so scrolling is
  listened for on the document in the capture phase.
*/
(function () {
  'use strict';
  if (window.__srpLoaded) return;
  window.__srpLoaded = true;

  var doc = document;
  var $ = function (s, el) { return (el || doc).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); };
  var PATHS = { check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>', x: '<path d="m7 7 10 10M17 7 7 17"/>' };
  function icon(name) { return '<svg class="srp-i" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + PATHS[name] + '</svg>'; }
  function esc(value) { var d = doc.createElement('span'); d.textContent = value == null ? '' : String(value); return d.innerHTML; }
  function readJSON(selector) {
    var el = $(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (error) { return null; }
  }
  function fill(pattern, map) {
    return String(pattern || '').replace(/\[(\w+)\]/g, function (all, key) { return key in map ? map[key] : all; });
  }
  var inEditor = function () { return !!(window.Shopify && window.Shopify.designMode); };
  var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  function lockScroll(on) { doc.documentElement.classList.toggle('srp-lock', !!on); }

  var state = { offers: [], sel: null, text: {}, busy: false, phones: null, brands: [], pick: null, sheetOpen: false, opener: null, revShown: 0 };

  /* ---------- offers ---------- */
  function offerBy(key) {
    for (var i = 0; i < state.offers.length; i++) if (state.offers[i].k === key) return state.offers[i];
    return null;
  }

  function loadOffers() {
    var data = readJSON('[data-srp-offers]');
    state.offers = (data && data.offers) || [];
    state.text = (data && data.text) || {};
    renderDeals();
    var keep = state.sel && offerBy(state.sel.k);
    select(keep ? keep.k : (data && data.selected));
  }

  function select(key) {
    var o = offerBy(key) || state.offers[0] || null;
    state.sel = o;
    var form = $('form.srp-form');

    if (o) {
      $$('[data-srp-b]').forEach(function (el) {
        var k = el.getAttribute('data-srp-b');
        if (!(k in o)) return;
        el.textContent = o[k];
        if (k === 'was' || k === 'badge' || k === 'note') el.hidden = !o[k];
      });
    }
    var gift = $('[data-srp-giftrow]');
    if (gift) gift.hidden = !o || !o.rings;
    var short = $('[data-srp-short]');
    if (short) short.hidden = !o || !o.short;

    $$('input[data-srp-offer]').forEach(function (input) {
      var on = !!o && input.value === o.k;
      input.checked = on;
      var row = input.closest('.srp-opt');
      if (row) row.classList.toggle('is-on', on);
    });
    $$('[data-srp-pick]').forEach(function (button) {
      button.setAttribute('aria-pressed', o && button.getAttribute('data-srp-pick') === o.k ? 'true' : 'false');
    });

    if (form && o) {
      var id = $('[data-srp-id]', form), qty = $('[data-srp-qty]', form), prop = $('[data-srp-prop]', form);
      if (id) id.value = o.variant;
      if (qty) qty.value = o.qty;
      if (prop) { prop.value = o.prop || ''; prop.disabled = !o.prop; }
    }

    var main = $('[data-srp-main-add]');
    var soldOut = main ? main.getAttribute('data-soldout') : '';
    var ready = !!(o && o.ok && form);
    $$('[data-srp-add]').forEach(function (button) {
      /* buttons in other sections only make sense when the buy box is on the page */
      button.hidden = !o || !form;
      if (!state.busy) button.disabled = !ready;
      var label = $('[data-srp-add-label]', button), price = $('[data-srp-add-price]', button);
      if (label) label.textContent = o && !o.ok ? (button.getAttribute('data-soldout') || soldOut) : button.getAttribute('data-label');
      if (price) price.hidden = !ready;
    });
    var stock = $('[data-srp-stock]');
    if (stock) stock.hidden = !(o && o.ok);
    onScroll();
  }

  /* rows in the "bundles" section: every offer after the first */
  function renderDeals() {
    $$('[data-srp-deals]').forEach(function (box) {
      var withSaving = box.getAttribute('data-pattern') || '[price]';
      var plain = box.getAttribute('data-pattern-plain') || '[price]';
      box.innerHTML = state.offers.slice(1).map(function (o) {
        var text = fill(o.save ? withSaving : plain, { price: o.price, amount: o.save, each: o.unit });
        return '<button class="srp-more__deal" type="button" data-srp-pick="' + esc(o.k) + '" aria-pressed="false"' + (o.ok ? '' : ' disabled') + '>' +
          '<span class="srp-opt__radio"></span><span class="srp-more__txt"><b>' + esc(o.title) + '</b><span>' + esc(text) + '</span></span></button>';
      }).join('');
    });
    /* "Two are R599 each, three are R549 each." written from the offers, so it can't go out of date */
    $$('[data-srp-deal-line]').forEach(function (el) {
      var pattern = el.getAttribute('data-pattern') || '';
      var text = state.offers.slice(1).filter(function (o) { return o.units > 1 && o.ok; }).map(function (o) {
        return fill(pattern, { count: WORDS[o.units] || o.units, units: o.units, each: o.unit, price: o.price, name: o.title });
      }).join(', ');
      el.textContent = text ? text.charAt(0).toUpperCase() + text.slice(1) + '.' : '';
    });
  }

  /* ---------- messages ---------- */
  var toastTimer = 0;
  function say(html) {
    var toast = $('[data-srp-toast]');
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-in'); }, 5200);
  }
  function showMsg(html, ok) {
    var msg = $('[data-srp-msg]');
    if (msg) {
      msg.innerHTML = html || '';
      msg.hidden = !html;
      msg.classList.toggle('is-ok', !!ok);
    }
    if (html) say(html);
  }

  /* ---------- add to cart ---------- */
  function storeRoot() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (base || '/').replace(/\/?$/, '/');
  }
  function drawerElement() { return doc.querySelector('theme-drawer#cart-drawer'); }

  function setBusy(busy) {
    $$('[data-srp-add]').forEach(function (button) {
      button.classList.toggle('is-busy', busy);
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    if (!busy && state.sel) select(state.sel.k);
  }

  function fetchCart() {
    return fetch(storeRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; resolve(null); } }, ms);
      Promise.resolve(promise).then(function (value) {
        if (done) return;
        done = true; clearTimeout(timer); resolve(value);
      }, function () {
        if (done) return;
        done = true; clearTimeout(timer); resolve(null);
      });
    });
  }

  /* Shopify's standard cart event lets the theme refresh its cart drawer and cart count.
     If that module can't load, an equivalent plain event is used instead. */
  function loadEvents() {
    var loader;
    try { loader = import('@shopify/events'); } catch (error) { loader = Promise.resolve(null); }
    return withTimeout(loader, 2500).then(function (mod) {
      return mod && mod.CartLinesUpdateEvent ? mod.CartLinesUpdateEvent : null;
    });
  }
  function createDeferred(LinesEvent) {
    if (LinesEvent && typeof LinesEvent.createPromise === 'function') {
      try { return LinesEvent.createPromise(); } catch (error) { /* plain promise below */ }
    }
    var deferred = {};
    deferred.promise = new Promise(function (resolve, reject) { deferred.resolve = resolve; deferred.reject = reject; });
    return deferred;
  }
  function createLinesEvent(LinesEvent, payload) {
    if (LinesEvent) {
      try { return new LinesEvent(payload); } catch (error) { /* plain event below */ }
    }
    var event = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
    Object.keys(payload).forEach(function (key) {
      try { Object.defineProperty(event, key, { value: payload[key] }); } catch (error) { /* ignore */ }
    });
    return event;
  }
  function cartSummary(LinesEvent, cart) {
    if (LinesEvent && typeof LinesEvent.createCartFromAjaxResponse === 'function') {
      try { return LinesEvent.createCartFromAjaxResponse(cart); } catch (error) { /* plain summary below */ }
    }
    return {
      id: cart.token,
      totalQuantity: cart.item_count,
      cost: { totalAmount: { amount: String((cart.total_price || 0) / 100), currencyCode: cart.currency } },
      lines: []
    };
  }
  /* Puts the fresh cart into the drawer when the theme did not do it itself. */
  function refreshDrawerContents(sectionHtml) {
    var drawer = drawerElement();
    if (!drawer || !sectionHtml || !window.DOMParser) return;
    var current = drawer.querySelector('.cart-drawer__inner');
    if (!current || !current.classList.contains('cart-drawer--empty')) return;
    var fresh = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.cart-drawer__inner');
    if (!fresh) return;
    current.className = fresh.className;
    current.innerHTML = fresh.innerHTML;
  }
  function openDrawer() {
    if (!drawerElement()) return Promise.resolve(false);
    var defined = window.customElements && window.customElements.whenDefined
      ? window.customElements.whenDefined('theme-drawer') : Promise.resolve();
    return withTimeout(defined, 4000).then(function () {
      var drawer = drawerElement();
      if (!drawer || typeof drawer.open !== 'function') return false;
      return new Promise(function (resolve) {
        setTimeout(function () {
          try { if (!drawer.isOpen) drawer.open(); resolve(true); } catch (error) { resolve(false); }
        }, 80);
      });
    });
  }
  function addedFallback() {
    showMsg(esc(state.text.added || 'Added to your cart.') + ' <a href="' + storeRoot() + 'checkout">' + esc(state.text.checkout || 'Go to checkout') + '</a>', true);
  }

  function addToDrawer(form) {
    var formData = new FormData(form);
    formData.delete('return_to');
    var sectionIds = ['cart-drawer-section'];
    $$('cart-items-component').forEach(function (item) {
      var id = item.dataset && item.dataset.sectionId;
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);
    var itemCount = Number(formData.get('quantity')) || 1;
    var merchandiseId = String(formData.get('id'));

    return loadEvents().then(function (LinesEvent) {
      return fetch(storeRoot() + 'cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok && !data.status, data: data };
        }, function () {
          return { ok: response.ok, data: {} };
        });
      }).then(function (result) {
        if (!result.ok) {
          showMsg(esc(result.data.description || result.data.message || state.text.error), false);
          return;
        }
        showMsg('');
        var sections = result.data.sections || {};
        var deferred = createDeferred(LinesEvent);
        form.dispatchEvent(createLinesEvent(LinesEvent, {
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: merchandiseId, quantity: itemCount }],
          promise: deferred.promise
        }));

        var drawerOpened = openDrawer();
        return fetchCart().then(function (cart) {
          deferred.resolve({
            cart: cartSummary(LinesEvent, cart),
            detail: { items: cart.items, source: 'snapreserve-product-page', sourceId: '', itemCount: itemCount, productId: '', sections: sections, didError: false }
          });
        }, function () {
          deferred.resolve({
            cart: { id: '', totalQuantity: itemCount, cost: { totalAmount: { amount: '0', currencyCode: '' } }, lines: [] },
            detail: { items: [], source: 'snapreserve-product-page', sourceId: '', itemCount: itemCount, productId: '', sections: sections, didError: false }
          });
        }).then(function () {
          return drawerOpened;
        }).then(function (opened) {
          setTimeout(function () { refreshDrawerContents(sections['cart-drawer-section']); }, 600);
          if (!opened) addedFallback();
        });
      });
    });
  }

  /* the phone picked in the phone check, as a note on the order (never required) */
  function syncPhoneProp(form) {
    var input = $('[data-srp-phone-prop]', form);
    if (!input) return;
    var note = phoneNote();
    var label = (state.phones && state.phones.prop) || 'Phone model';
    input.name = 'properties[' + label + ']';
    input.value = note;
    input.disabled = !note;
  }

  function onSubmit(event, form) {
    syncPhoneProp(form);
    /* without fetch the browser posts the form and Shopify shows the cart page */
    if (!window.fetch || !window.FormData || !window.Promise) return;
    if (event) event.preventDefault();
    var o = state.sel;
    if (state.busy || !o || !o.ok) return;
    state.busy = true;
    setBusy(true);
    showMsg('');
    addToDrawer(form).catch(function () {
      showMsg(esc(state.text.error || 'Something went wrong. Please try again.'), false);
    }).then(function () {
      state.busy = false;
      setBusy(false);
    });
  }

  function submitMain() {
    var form = $('form.srp-form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else onSubmit(null, form);
  }

  /* ---------- gallery ---------- */
  function setPoster(video) {
    var src = video.getAttribute('data-poster');
    if (src && !video.getAttribute('poster')) video.setAttribute('poster', src);
  }

  function initGallery(gal) {
    if (gal.__srp) return;
    gal.__srp = true;
    var track = $('[data-srp-track]', gal);
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = $$('.srp-thumb', gal), dots = $$('.srp-dot', gal), cur = 0, raf = 0;

    /* a slide is fetched just before it is needed */
    function warm(i) {
      var el = slides[i];
      if (!el) return;
      if (el.tagName === 'IMG') { if (el.getAttribute('loading') === 'lazy') el.setAttribute('loading', 'eager'); }
      else { var v = $('video', el); if (v) setPoster(v); }
    }
    function mark(i) {
      cur = i;
      [thumbs, dots].forEach(function (set) {
        set.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      });
      warm(i); warm(i + 1);
    }
    gal.__go = function (i, instant) {
      warm(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { gal.__go(i); }); });
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { if (track.clientWidth) mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'focus'].forEach(function (name) {
      track.addEventListener(name, function () { warm(cur + 1); }, { passive: true });
    });
    setTimeout(function () { warm(1); }, 2500);
  }

  /* ---------- clips: play while on screen, pause when not. With reduced motion they wait for a tap.
     If a clip can't load, its still picture stays in its place. ---------- */
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var watch = !calm && hasIO ? new IntersectionObserver(function (items) {
    items.forEach(function (it) {
      var v = it.target, clip = v.parentNode;
      if (!clip) return;
      if (it.isIntersecting && it.intersectionRatio >= 0.5) { if (!clip.__held && clip.__start) clip.__start(); }
      else v.pause();
    });
  }, { threshold: [0, 0.5, 1] }) : null;
  var near = hasIO ? new IntersectionObserver(function (items) {
    items.forEach(function (it) { if (it.isIntersecting) { setPoster(it.target); near.unobserve(it.target); } });
  }, { rootMargin: '800px 0px' }) : null;

  function initClip(clip) {
    if (clip.__srp) return;
    clip.__srp = true;
    var v = $('video', clip), btn = $('.srp-clip__btn', clip);
    if (!v || !btn) return;
    function show() {
      clip.classList.toggle('is-paused', v.paused);
      btn.setAttribute('aria-label', v.paused ? (state.text.play || 'Play video') : (state.text.pause || 'Pause video'));
    }
    function still() {
      if (!v.parentNode) return;
      var src = v.getAttribute('poster') || v.getAttribute('data-poster');
      if (watch) watch.unobserve(v);
      clip.classList.add('is-still');
      if (!src) return;
      var img = doc.createElement('img');
      img.src = src; img.alt = v.getAttribute('aria-label') || ''; img.width = 864; img.height = 864;
      clip.replaceChild(img, v);
    }
    clip.__start = function () { var pr = v.play(); if (pr && pr.catch) pr.catch(show); };
    v.addEventListener('play', show);
    v.addEventListener('pause', show);
    v.addEventListener('error', still);
    btn.addEventListener('click', function () {
      if (v.paused) { clip.__held = false; clip.__start(); } else { clip.__held = true; v.pause(); }
    });
    if (v.error) { still(); return; }
    if (!clip.closest('[data-srp-gal]')) { if (near) near.observe(v); else setPoster(v); }
    if (calm) v.pause();
    if (watch) watch.observe(v);
    show();
  }

  /* ---------- phone check ---------- */
  function loadPhones() {
    state.phones = readJSON('[data-srp-phones]');
    var list = (state.phones && state.phones.phones) || [];
    var sheet = $('[data-srp-sheet]');
    var has = !!(sheet && list.length);
    $$('[data-srp-check]').forEach(function (button) { button.hidden = !has; });
    state.brands = [];
    if (!has) return;
    list.forEach(function (p) {
      var brand = null;
      state.brands.forEach(function (b) { if (b.name === p.brand) brand = b; });
      if (!brand) { brand = { name: p.brand, items: [] }; state.brands.push(brand); }
      brand.items.push(p);
    });
    var box = $('[data-srp-brands]', sheet);
    box.style.gridTemplateColumns = 'repeat(' + Math.min(4, Math.max(1, state.brands.length)) + ', 1fr)';
    box.innerHTML = state.brands.map(function (b, i) {
      return '<button class="srp-brand" type="button" aria-pressed="false" data-srp-brand="' + i + '">' + esc(b.name) + '</button>';
    }).join('');
    /* keep the shopper's choice when the section is redrawn in the editor */
    var pick = state.pick;
    state.pick = null;
    if (pick && state.brands[pick.b]) {
      chooseBrand(pick.b);
      var model = $('[data-srp-model]', sheet);
      if (pick.m != null && state.brands[pick.b].items[pick.m]) { model.value = String(pick.m); showFit(); }
    } else {
      sumFit(null);
    }
  }

  function picked() {
    var pick = state.pick;
    if (!pick || pick.m == null) return null;
    var brand = state.brands[pick.b];
    return (brand && brand.items[pick.m]) || null;
  }

  function chooseBrand(index) {
    var sheet = $('[data-srp-sheet]'), brand = state.brands[index];
    if (!sheet || !brand) return;
    var t = state.phones.text || {};
    state.pick = { b: index, m: null };
    $$('[data-srp-brand]', sheet).forEach(function (button) {
      button.setAttribute('aria-pressed', Number(button.getAttribute('data-srp-brand')) === index ? 'true' : 'false');
    });
    var allGeneric = brand.items.every(function (p) { return p.generic; });
    var model = $('[data-srp-model]', sheet);
    model.innerHTML = '<option value="">' + esc(allGeneric ? t.promptGeneric : t.promptModel) + '</option>' +
      brand.items.map(function (p, i) { return '<option value="' + i + '">' + esc(p.label) + '</option>'; }).join('');
    $('[data-srp-model-wrap]', sheet).hidden = false;
    var phone = $('[data-srp-phone]', sheet);
    if (phone) phone.value = '';
    showFit();
  }

  function fitRow(kind, bold, text) {
    var mark = kind === 'yes' ? '<span class="srp-tick">' + icon('check') + '</span>'
      : kind === 'no' ? '<span class="srp-no">' + icon('x') + '</span>'
      : '<span class="srp-ask" aria-hidden="true">?</span>';
    return '<li>' + mark + '<span><b>' + esc(bold) + '</b> ' + esc(text) + '</span></li>';
  }

  function showFit() {
    var sheet = $('[data-srp-sheet]');
    if (!sheet) return;
    var model = $('[data-srp-model]', sheet), fit = $('[data-srp-fit]', sheet);
    if (state.pick) state.pick.m = model.value === '' ? null : Number(model.value);
    var p = picked();
    if (!p) { fit.hidden = true; sumFit(null); return; }
    var t = state.phones.text || {}, cable = t.cable || {};
    var direct = p.snap === 'direct';
    $('[data-srp-fit-top]', sheet).textContent = p.wireless === 'yes' ? (direct ? t.topDirect : t.topRing)
      : p.wireless === 'no' ? t.topNoWireless : t.topUnknown;
    $('[data-srp-fit-rows]', sheet).innerHTML =
      fitRow('yes', t.rowCable, cable[p.cable] || '') +
      fitRow('yes', t.rowSnap, direct ? t.snapDirect : t.snapRing) +
      (p.wireless === 'yes' ? fitRow('yes', t.rowWireless, t.wirelessYes)
        : p.wireless === 'no' ? fitRow('no', t.rowWireless, t.wirelessNo)
        : fitRow('ask', t.rowWireless, t.wirelessUnknown));
    $('[data-srp-fit-exact]', sheet).hidden = direct;
    var phone = $('[data-srp-phone]', sheet);
    if (phone) phone.placeholder = p.example || '';
    fit.hidden = false;
    sumFit(p);
  }

  /* the answer in one line, next to the Add to cart button */
  function sumFit(p) {
    var sum = $('[data-srp-fit-sum]'), button = $('[data-srp-fit-btn]');
    if (!sum || !button) return;
    if (!p) {
      sum.textContent = sum.getAttribute('data-default') || '';
      button.textContent = button.getAttribute('data-label') || '';
      return;
    }
    var t = state.phones.text || {};
    var text = p.wireless === 'yes' ? (p.snap === 'direct' ? t.sumDirect : t.sumRing)
      : p.wireless === 'no' ? t.sumNoWireless : t.sumUnknown;
    var name = doc.createElement('b');
    name.textContent = (p.generic ? t.yourPhone : p.label) + ':';
    sum.textContent = ' ' + text;
    sum.insertBefore(name, sum.firstChild);
    button.textContent = button.getAttribute('data-change') || button.getAttribute('data-label') || '';
  }

  function phoneNote() {
    var p = picked();
    if (!p) return '';
    var sheet = $('[data-srp-sheet]');
    var input = sheet && $('[data-srp-phone]', sheet);
    var exact = sheet && $('[data-srp-fit-exact]', sheet);
    var typed = input && exact && !exact.hidden ? input.value.trim() : '';
    return typed || (p.generic ? '' : p.label);
  }

  function openSheet(from) {
    var sheet = $('[data-srp-sheet]');
    if (!sheet) return;
    /* on wide screens the open cart drawer keeps keyboard focus inside itself: close it first */
    var drawer = drawerElement();
    if (drawer && drawer.isOpen && typeof drawer.close === 'function') { try { drawer.close(); } catch (error) { /* ignore */ } }
    state.opener = from || null;
    state.sheetOpen = true;
    sheet.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-in'); }); });
    var panel = $('.srp-sheet__panel', sheet);
    if (panel && !inEditor()) panel.focus();
  }
  function closeSheet() {
    var sheet = $('[data-srp-sheet]');
    state.sheetOpen = false;
    lockScroll(false);
    if (!sheet) return;
    sheet.classList.remove('is-in');
    sheet.hidden = true;
    if (state.opener && state.opener.focus && doc.contains(state.opener)) state.opener.focus();
    state.opener = null;
  }

  /* ---------- reviews (from the "Customer reviews" area) ---------- */
  function collectReviews() {
    var ticked = {};
    $$('[data-sr-rv-source] [data-rv-compact]').forEach(function (el) {
      var who = $('strong', el);
      ticked[(el.getAttribute('data-sort') || '') + '|' + (who ? who.textContent.trim() : '')] = true;
    });
    var list = [];
    $$('[data-sr-rv-source] [data-rv-card]').forEach(function (card, index) {
      var pick = function (s) { var el = $(s, card); return el ? el.textContent.trim() : ''; };
      var body = $('.sr-rv-card__body', card);
      var name = pick('.sr-rv-card__name');
      var sort = card.getAttribute('data-sort') || '';
      list.push({
        index: index,
        sort: sort,
        rating: parseInt(card.getAttribute('data-rating'), 10) || 0,
        title: pick('.sr-rv-card__title'),
        body: body ? body.innerHTML : '',
        name: name,
        date: pick('.sr-rv-card__date'),
        verified: !!$('.sr-rv-verified', card),
        under: !!ticked[sort + '|' + name],
        photos: $$('.sr-rv-card__photo', card).map(function (a) {
          var img = $('img', a);
          return { href: a.getAttribute('href'), src: img ? img.getAttribute('src') : '' };
        })
      });
    });
    list.sort(function (a, b) { return a.sort < b.sort ? 1 : a.sort > b.sort ? -1 : a.index - b.index; });
    return list;
  }

  /* the fill follows the star shapes: 17 units per star with a 6 unit gap, on a strip of 112 */
  function starPct(rating) {
    var r = Math.max(0, Math.min(5, rating));
    if (r >= 5) return 100;
    var whole = Math.floor(r);
    return Math.round(((whole * 23 + 1.49 + (r - whole) * 17.02) / 112) * 10000) / 100;
  }

  function starsHtml(rating, label) {
    var sample = $('[data-srp-stars]');
    if (!sample || !rating) return '';
    var copy = sample.cloneNode(true);
    copy.className = 'srp-stars srp-rev__stars';
    copy.removeAttribute('data-srp-stars');
    copy.style.setProperty('--pct', starPct(rating) + '%');
    copy.setAttribute('aria-label', label);
    return copy.outerHTML;
  }

  function reviewCard(r, opts) {
    var meta = [];
    if (r.verified && opts.verified) meta.push(icon('check') + esc(opts.verified));
    if (r.date && opts.dates) meta.push(esc(r.date));
    return '<article class="srp-rev">' +
      '<div class="srp-rev__who"><span class="srp-ava" aria-hidden="true">' + esc(r.name.charAt(0).toUpperCase()) + '</span><div>' +
      '<div class="srp-rev__name">' + esc(r.name) + '</div>' +
      (meta.length ? '<div class="srp-rev__meta">' + meta.join(' · ') + '</div>' : '') + '</div></div>' +
      (opts.stars ? starsHtml(r.rating, fill(opts.label, { rating: r.rating })) : '') +
      (r.title ? '<h3 class="srp-rev__title">' + esc(r.title) + '</h3>' : '') +
      '<p class="srp-rev__text">' + r.body + '</p>' +
      (r.photos.length ? '<div class="srp-rev__photos">' + r.photos.map(function (p) {
        return '<a href="' + esc(p.href) + '" target="_blank" rel="noopener"><img src="' + esc(p.src) + '" width="64" height="64" loading="lazy" alt=""></a>';
      }).join('') + '</div>' : '') +
      '</article>';
  }

  function renderReviews() {
    var all = collectReviews();
    var rated = all.filter(function (r) { return r.rating >= 1 && r.rating <= 5; });
    var avg = rated.length ? rated.reduce(function (sum, r) { return sum + r.rating; }, 0) / rated.length : 0;
    var avgText = (Math.round(avg * 10) / 10).toFixed(1);

    if (all.length && rated.length) {
      $$('[data-srp-rating][data-auto]').forEach(function (box) {
        var stars = $('[data-srp-stars]', box), num = $('[data-srp-rating-num]', box), count = $('[data-srp-rating-count]', box);
        if (stars) {
          stars.style.setProperty('--pct', starPct(avg) + '%');
          stars.setAttribute('aria-label', fill(box.getAttribute('data-label'), { rating: avgText }));
        }
        if (num) num.textContent = avgText;
        if (count) count.textContent = fill(box.getAttribute('data-count-text'), { count: all.length });
      });
    }

    /* row under the buy button: ticked reviews first, then the newest verified 5-star ones */
    $$('[data-srp-strip]').forEach(function (strip) {
      var want = parseInt(strip.getAttribute('data-count'), 10) || 0;
      var chosen = all.filter(function (r) { return r.under; });
      all.forEach(function (r) { if (chosen.length < want && !r.under && r.rating === 5 && r.verified) chosen.push(r); });
      chosen = chosen.slice(0, want);
      strip.hidden = !chosen.length;
      $('[data-srp-strip-list]', strip).innerHTML = chosen.map(function (r) {
        return reviewCard(r, { verified: strip.getAttribute('data-verified'), dates: true, stars: false });
      }).join('');
    });

    $$('[data-srp-reviews]').forEach(function (section) {
      var list = $('[data-srp-revlist]', section), more = $('[data-srp-rev-more]', section), empty = $('[data-srp-rev-empty]', section);
      if (!all.length) {
        list.innerHTML = '';
        more.hidden = true;
        if (empty) empty.hidden = false; else section.hidden = true;
        return;
      }
      section.hidden = false;
      if (empty) empty.hidden = true;
      var wide = window.matchMedia('(min-width: 900px)').matches;
      var step = parseInt(section.getAttribute(wide ? 'data-first' : 'data-first-mobile'), 10) || (wide ? 9 : 4);
      var shown = Math.min(all.length, Math.max(step, state.revShown));
      state.revShown = shown;
      var opts = {
        verified: section.getAttribute('data-verified'),
        dates: section.hasAttribute('data-dates'),
        stars: section.hasAttribute('data-stars'),
        label: (($('[data-srp-rating]', section) || section).getAttribute('data-label')) || '[rating] / 5'
      };
      list.innerHTML = all.slice(0, shown).map(function (r) { return reviewCard(r, opts); }).join('');
      var left = all.length - shown;
      more.hidden = left <= 0;
      more.textContent = fill(section.getAttribute('data-more'), { count: Math.min(step, left) });
      more.__step = step;
    });
  }

  /* ---------- buy bar: follows once the main button has scrolled out of view, and steps aside
     whenever another Add to cart button, or the footer, is on screen ---------- */
  function onScroll() {
    var sticky = $('[data-srp-sticky]'), add = $('[data-srp-main-add]');
    if (!sticky || !add) return;
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    var past = add.getBoundingClientRect().bottom < 0;
    var seen = $$('[data-srp-add]').some(function (b) {
      if (b === add || sticky.contains(b)) return false;
      var r = b.getBoundingClientRect();
      return r.height > 0 && r.bottom > 0 && r.top < vh - 60;
    });
    var footer = $('.shopify-section-group-footer-group');
    var atFooter = !!footer && footer.getBoundingClientRect().top < vh - 40;
    var show = past && !seen && !atFooter && !!state.sel && !state.sheetOpen;
    sticky.classList.toggle('is-in', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    var button = $('button', sticky);
    if (button) button.tabIndex = show ? 0 : -1;
  }

  /* ---------- events (delegated, so sections redrawn by the theme editor keep working) ---------- */
  doc.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches) return;
    if (t.matches('input[data-srp-offer]')) select(t.value);
    else if (t.matches('[data-srp-model]')) {
      var phone = $('[data-srp-phone]');
      if (phone) phone.value = '';
      showFit();
    }
  });

  doc.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-srp-pick]'))) {
      var key = el.getAttribute('data-srp-pick');
      /* tap a selected row again to go back to the first offer */
      select(state.sel && state.sel.k === key && state.offers[0] ? state.offers[0].k : key);
    } else if ((el = t.closest('[data-srp-add]'))) {
      if (el.type !== 'submit') { event.preventDefault(); submitMain(); }
    } else if ((el = t.closest('[data-srp-check]'))) {
      event.preventDefault();
      openSheet(el);
    } else if ((el = t.closest('[data-srp-close]'))) {
      closeSheet();
    } else if ((el = t.closest('[data-srp-brand]'))) {
      chooseBrand(Number(el.getAttribute('data-srp-brand')));
    } else if ((el = t.closest('[data-srp-rev-more]'))) {
      state.revShown += el.__step || 5;
      renderReviews();
    } else if ((el = t.closest('[data-srp-scroll]'))) {
      var target = null;
      try { target = $(el.getAttribute('href')); } catch (error) { target = null; }
      if (target && !target.hidden) {
        event.preventDefault();
        target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });

  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form.srp-form')) onSubmit(event, form);
  });

  doc.addEventListener('keydown', function (event) {
    var sheet = $('[data-srp-sheet]');
    if (!sheet || sheet.hidden) return;
    if (event.key === 'Escape') { closeSheet(); return; }
    if (event.key !== 'Tab') return;
    var panel = $('.srp-sheet__panel', sheet);
    var items = $$('button, select, input, a[href]', panel).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], at = doc.activeElement;
    if (event.shiftKey && (at === first || at === panel)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && at === last) { event.preventDefault(); first.focus(); }
  });

  var scrollFrame = 0;
  function onScrollSoon() {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(function () { scrollFrame = 0; onScroll(); });
  }
  doc.addEventListener('scroll', onScrollSoon, { passive: true, capture: true });
  window.addEventListener('resize', onScrollSoon);

  /* ---------- start, and start again whenever the theme editor redraws a section ---------- */
  function boot() {
    loadOffers();
    loadPhones();
    $$('[data-srp-gal]').forEach(initGallery);
    $$('.srp-clip').forEach(initClip);
    renderReviews();
    onScroll();
  }

  doc.addEventListener('shopify:section:load', function () {
    boot();
    if (!state.sheetOpen) lockScroll(false);
  });
  doc.addEventListener('shopify:section:unload', function (event) {
    if (event.target && $('[data-srp-sheet]', event.target)) { state.sheetOpen = false; lockScroll(false); }
  });
  doc.addEventListener('shopify:section:select', function (event) {
    if (event.target && $('[data-srp-sheet]', event.target)) openSheet();
  });
  doc.addEventListener('shopify:section:deselect', function (event) {
    if (event.target && $('[data-srp-sheet]', event.target)) closeSheet();
  });
  doc.addEventListener('shopify:block:select', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.tagName === 'DETAILS') { t.open = true; return; }
    var gal = t.closest('[data-srp-gal]');
    var track = gal && $('[data-srp-track]', gal);
    if (track && t.parentNode === track && gal.__go) gal.__go(Array.prototype.indexOf.call(track.children, t), true);
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
